module.exports = __webpack_public_path__ + "img/tea-time-8100595_1280_thumb.816533ed.jpg";